import { useState } from "react";
import ReactDatePicker from "react-datepicker";
import styles from "../../styles/_sections/_shackClosing/add.module.scss";

const Add = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  return (
    <div className={styles.container}>
      <div className={styles.field}>
        <label>From</label>
        <ReactDatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
        />
      </div>
      <div className={styles.field}>
        <label>To</label>
        <ReactDatePicker
          selected={endDate}
          onChange={(date) => setEndDate(date)}
        />
      </div>

      <div className={styles.field}>
        <label>Reason for closure</label>
        <input type="text" name="reason" placeholder="Reason for closure" />
      </div>

      <button className={styles.btn}>Add a day to close</button>
    </div>
  );
};

export default Add;
